<router-outlet></router-outlet>

<!-- Base confirm dialog -->
<p-confirmDialog
  #baseDialog
  styleClass="max-w-xl bg-white p-8 flex flex-col gap-12">
  <ng-template
    let-dialog
    pTemplate="headless">
    @if (castAsConfirmation(dialog); as dialog) {
      <div class="flex grow flex-col gap-6">
        @if (dialog.header) {
          <h2 class="text-xl font-bold">{{ dialog.header }}</h2>
        }

        @if (dialog.message) {
          <p
            class="text-regular text-base"
            [innerHTML]="dialog.message"></p>
        }
      </div>

      <div class="flex justify-end gap-4">
        @if (dialog.rejectVisible !== false) {
          <p-button
            styleClass="h-full"
            outlined
            (onClick)="dialog.reject ? dialog.reject() : undefined; baseDialog.close($event)"
            >{{ dialog.rejectLabel ?? ('i18n.Common.cancel' | translate) }}</p-button
          >
        }

        @if (dialog.acceptVisible !== false) {
          <p-button
            styleClass="h-full flex items-center gap-2"
            [severity]="dialog.acceptButtonSeverity"
            (onClick)="dialog.accept ? dialog.accept() : undefined; baseDialog.close($event)">
            @if (dialog.acceptIcon) {
              <svg-icon
                size="lg"
                [key]="dialog.acceptIcon" />
            }
            {{ dialog.acceptLabel ?? ('i18n.Common.confirm' | translate) }}
          </p-button>
        }
      </div>
    }
  </ng-template>
</p-confirmDialog>

<!-- Base toast -->
<p-toast
  position="top-right"
  styleClass="w-[500px]"
  [baseZIndex]="5000"
  [life]="5000">
  <ng-template
    let-message
    pTemplate="message">
    <div class="flex w-full items-center justify-between">
      <svg-icon
        size="xl"
        [key]="getToastIcon(message.severity)"></svg-icon>

      <span class="mx-3 text-base text-black">{{ message.detail }}</span>
    </div>
  </ng-template>
</p-toast>
